/**
 * Member transcripts skip settled-turn interiors on the server and load them
 * per turn when the turn is on screen (see use-compacted-turn-details.ts).
 * Prefetch, server preload, and optimistic updates must send the same args
 * to share a cache. Shared by client hooks and server preloading.
 */
export const COMPACTED_TRANSCRIPT_ARGS = {
  compactTerminalTurns: true,
} as const;

export function memberTranscriptArgsForRoute(routeRef: string) {
  return { routeRef, ...COMPACTED_TRANSCRIPT_ARGS };
}

/** Order-independent key for the transcript query's non-pagination args. */
export function transcriptArgsKey(args: object | 'skip'): string | null {
  if (args === 'skip') return null;
  return JSON.stringify(
    Object.fromEntries(
      Object.entries(args).sort(([a], [b]) => a.localeCompare(b))
    )
  );
}
